import React from "react";
import AutoSizeTitle from "../../../components/autoSizeTitle/AutoSizeTitle";
import IndividualInformHeader from "../../../components/individualInformHeader/individualInformHeader";
import GapChartSelfcare360 from "../../../graphics/selfcare360/gapChartSelfcare360";
import { roundHalfUp } from "../../../components/selfcare360/selfcare360Scales";
import "../../../components/selfcare360/resumeSelfcare360.css";

const getAutoRelationshipAverage = (averageByRelationship = {}) => {
    const autoKeys = ['AUTO', 'AUTOEVALUACION', 'AUTOEVALUACIÓN'];

    for (const key of autoKeys) {
        const value = Number(averageByRelationship?.[key]);
        if (Number.isFinite(value)) return value;
    }

    return null;
};

const PageResumeGapSelfcare360 = ({ selectedEvaluation, individualResult, pageNumber, orgLogo }) => {
    const backgroundStyle = {
        backgroundImage: `url("/informs/pagina.png")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left top",
        backgroundSize: "100% auto",
    };

    const dimensions = Object.entries(individualResult?.average_by_dimension || {})
        .filter(([key]) => !key.toLowerCase().includes("general"))
        .map(([key, value]) => {
            const directAuto = Number(value?.auto);
            const fallbackAuto = getAutoRelationshipAverage(value?.average_by_relationship);
            const resolvedAuto = Number.isFinite(directAuto) && directAuto > 0 ? directAuto : fallbackAuto;

            return {
                key,
                title: value?.title,
                auto: resolvedAuto != null ? roundHalfUp(resolvedAuto, 1) : null,
                others: roundHalfUp(Number(value?.another), 1),
            };
        })
        .filter((d) => d.title);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />
                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />
                    <div className="selfcare360-resume-title">Análisis de brechas (autopercepción vs. otros)</div>
                    <GapChartSelfcare360 dimensions={dimensions} />
                </div>
                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeGapSelfcare360;
